import React, { Component, PropTypes } from 'react';
import Message from '../../../message/Message';
import ReactSparkTextInput from '../../../widgets/ReactSparkTextInput';
import ConfigurationCheckbox from '../../../widgets/ConfigurationCheckbox';
import { get, trim, last, first } from 'lodash';
import './SalesforceSection.scss';
import isValidDomain from 'is-valid-domain';

class SalesforceSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            salesforceLinkErrorMessage: '',
            salesforceLinkSuccessMessage: '',
            salesforceCssLinkErrorMessage: '',
            salesforceCssLinkSuccessMessage: '',
            salesforceJsLinkSuccessMessage: '',
            salesforceJsLinkErrorMessage: ''
        };
    }

    getDomain = link => {
        const trimmedSalesforceLink = trim(link);
        return first(last(trimmedSalesforceLink.split('://')).split('/'));
    };

    render() {
        const { setConfigText, currentConfigCopy } = this.props;
        return (
            <section className="content-section salesforce">
                <h4>Salesforce Sign-In and Enrollment</h4>
                <Message
                    heading="Enable this setting as part of Sign-In/Enrollment Settings."
                    body=""
                    bodyLink="Go to Pages > Global Bar > Sign-In Settings > Salesforce Option"
                    bodyLinkUrl="/pages/globalBar/settings"
                    bodyLinkUrlStyle="app-navigation-link"
                    noBorder
                    noBackground
                    panelClassName="spark-mar-l-2"
                    messagePanelClassName="spark-pad-0"
                    type="info"
                />
                <Message
                    heading="Salesforce API documentation required for implementation"
                    body="See documentation to understand what is expected in the following fields."
                    noBorder
                    noBackground
                    panelClassName="spark-mar-l-2"
                    messagePanelClassName="spark-pad-0"
                    type="warning"
                />
                <div className="indent-left space-bottom-small">
                    <ReactSparkTextInput
                        label="Synxis SSO CRM Application ID"
                        value={get(
                            currentConfigCopy,
                            'crm.salesforceIntegrationKeys.salesforceSynxisSsoCrmApplicationId'
                        )}
                        onChange={event => {
                            setConfigText(
                                'crm.salesforceIntegrationKeys.salesforceSynxisSsoCrmApplicationId',
                                event.target.value
                            );
                        }}
                    />
                </div>
                <div className="indent-left space-bottom-small">
                    <ReactSparkTextInput
                        label="Salesforce Community Link"
                        value={get(currentConfigCopy, 'crm.salesforceIntegrationKeys.salesforceCommunityLink')}
                        onChange={event => {
                            setConfigText('crm.salesforceIntegrationKeys.salesforceCommunityLink', event.target.value);
                        }}
                        successMessage={this.state.salesforceLinkSuccessMessage}
                        errorMessage={this.state.salesforceLinkErrorMessage}
                        onBlur={() => {
                            const salesforceLinkDomain = this.getDomain(
                                get(currentConfigCopy, 'crm.salesforceIntegrationKeys.salesforceCommunityLink')
                            );
                            const isDomainValid = isValidDomain(salesforceLinkDomain);
                            if (isDomainValid) {
                                this.setState({
                                    salesforceLinkSuccessMessage:
                                        'This domain will be added to allowed domains when settings are saved.',
                                    salesforceLinkErrorMessage: ''
                                });
                                this.props.addSalesforceAllowedDomain('salesforceLink', salesforceLinkDomain);
                            } else {
                                this.setState({
                                    salesforceLinkErrorMessage:
                                        'Please enter a valid domain format. Eg. http://domain.com or https://www.domain.com',
                                    salesforceLinkSuccessMessage: ''
                                });
                            }
                        }}
                    />
                </div>
                <div className="indent-left space-bottom-small">
                    <ReactSparkTextInput
                        label="Salesforce Client ID"
                        value={get(currentConfigCopy, 'crm.salesforceIntegrationKeys.salesforceClientId')}
                        onChange={event => {
                            setConfigText('crm.salesforceIntegrationKeys.salesforceClientId', event.target.value);
                        }}
                    />
                </div>
                <div className="indent-left space-bottom-small">
                    <ReactSparkTextInput
                        label="Link to Salesforce Sign-In/Sign-Up Widget Stylesheet (CSS)"
                        value={get(currentConfigCopy, 'crm.salesforceIntegrationKeys.salesforceStylesheetUrl')}
                        successMessage={this.state.salesforceCssLinkSuccessMessage}
                        errorMessage={this.state.salesforceCssLinkErrorMessage}
                        onChange={event => {
                            setConfigText('crm.salesforceIntegrationKeys.salesforceStylesheetUrl', event.target.value);
                        }}
                        onBlur={() => {
                            const salesforceCssLinkDomain = this.getDomain(
                                get(currentConfigCopy, 'crm.salesforceIntegrationKeys.salesforceStylesheetUrl')
                            );
                            const isDomainValid = isValidDomain(salesforceCssLinkDomain);
                            if (isDomainValid) {
                                this.setState({
                                    salesforceCssLinkSuccessMessage:
                                        'This domain will be added to allowed domains when settings are saved.',
                                    salesforceCssLinkErrorMessage: ''
                                });
                                this.props.addSalesforceAllowedDomain('salesforceCssLink', salesforceCssLinkDomain);
                            } else {
                                this.setState({
                                    salesforceCssLinkErrorMessage:
                                        'Please enter a valid domain format. Eg. http://domain.com or https://www.domain.com',
                                    salesforceCssLinkSuccessMessage: ''
                                });
                            }
                        }}
                    />
                </div>
                <div className="indent-left space-bottom-small">
                    <ReactSparkTextInput
                        label="Link to Salesforce Sign-In/Sign-Up Widget Script (JS)"
                        value={get(currentConfigCopy, 'crm.salesforceIntegrationKeys.salesforceScriptUrl')}
                        successMessage={this.state.salesforceJsLinkSuccessMessage}
                        errorMessage={this.state.salesforceJsLinkErrorMessage}
                        onChange={event => {
                            setConfigText('crm.salesforceIntegrationKeys.salesforceScriptUrl', event.target.value);
                        }}
                        onBlur={() => {
                            const salesforceJsLinkDomain = this.getDomain(
                                get(currentConfigCopy, 'crm.salesforceIntegrationKeys.salesforceScriptUrl')
                            );
                            const isDomainValid = isValidDomain(salesforceJsLinkDomain);
                            if (isDomainValid) {
                                this.setState({
                                    salesforceJsLinkSuccessMessage:
                                        'This domain will be added to allowed domains when settings are saved.',
                                    salesforceJsLinkErrorMessage: ''
                                });
                                this.props.addSalesforceAllowedDomain('salesforceJsLink', salesforceJsLinkDomain);
                            } else {
                                this.setState({
                                    salesforceJsLinkErrorMessage:
                                        'Please enter a valid domain format. Eg. http://domain.com or https://www.domain.com',
                                    salesforceJsLinkSuccessMessage: ''
                                });
                            }
                        }}
                    />
                </div>
                <div className="indent-left space-bottom-small">
                    <ConfigurationCheckbox
                        title="Show Sign-Up link on the Sign-In form"
                        code="crm.salesforceIntegrationKeys.salesforceEnableSignUp"
                        onChange={(code, value) => {
                            this.props.toggleConfigBoolean(code, value);
                        }}
                        value={get(currentConfigCopy, 'crm.salesforceIntegrationKeys.salesforceEnableSignUp')}
                    />
                </div>
            </section>
        );
    }
}

SalesforceSection.propTypes = {
    configurationObject: PropTypes.shape({
        advertiserId: PropTypes.string,
        channel: PropTypes.string.isRequired,
        advertiserIdIsInvalid: PropTypes.bool,
        enabled: PropTypes.bool.isRequired
    }).isRequired,
    setValue: PropTypes.func.isRequired
};

export default SalesforceSection;



// WEBPACK FOOTER //
// ./src/components/pages/manage/apps/SalesforceSection.js